import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../../../components/FrontPage/Navbar";
import HeroBanner from "../../../components/FrontPage/HeroBanner";
import KeyFeatures from "../../../components/FrontPage/KeyFeatures";
import Footer from "../../../components/FrontPage/Footer";

const LandingPage: React.FC = () => {
  return (
    <>
      <div className="bg-white dark:bg-[#0a0e19]">
        <Navbar />
        <HeroBanner />
        <KeyFeatures />
        <Footer />
      </div>
    </>
  );
};

export default LandingPage;

